"use client"

import { useState } from "react"
import Downloads from "./Downloads"
import Swal from "sweetalert2"
import { useTranslations } from "../../translations"

const DownloadsContainer = () => {
  const { t } = useTranslations()
  const [downloadStatus, setDownloadStatus] = useState({
    manual1: false,
    manual2: false,
    manual3: false,
    manual4: false,
    manual5: false,
    manual6: false,
    manual7: false,
    manual8: false,
  })

  const [isDownloading, setIsDownloading] = useState({
    manual1: false,
    manual2: false,
    manual3: false,
    manual4: false,
    manual5: false,
    manual6: false,
    manual7: false,
    manual8: false,
  })

  const handleDownload = (pdfId, pdfName) => {
    // Encontrar el archivo PDF correspondiente
    const pdfFile = pdfFiles.find((pdf) => pdf.id === pdfId)
    if (!pdfFile) return

    // Set downloading state
    setIsDownloading((prev) => ({
      ...prev,
      [pdfId]: true,
    }))

    // Crear un enlace para descargar el archivo
    const link = document.createElement("a")
    link.href = pdfFile.filePath
    link.download = `${pdfName}.pdf`

    // Iniciar la descarga
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // Simular un tiempo de descarga para mostrar el progreso
    // En una aplicación real, podrías usar XMLHttpRequest para rastrear el progreso real
    setTimeout(() => {
      // Update download status
      setDownloadStatus((prev) => ({
        ...prev,
        [pdfId]: true,
      }))

      // Reset downloading state
      setIsDownloading((prev) => ({
        ...prev,
        [pdfId]: false,
      }))

      // Show success notification
      Swal.fire({
        title: t("downloadCompleteTitle"),
        text: `${pdfName}: ${t("downloadCompleteText")}`,
        icon: "success",
        confirmButtonText: t("accept"),
        confirmButtonColor: "#28a745",
        showCancelButton: false,
        allowOutsideClick: false,
      })
    }, 1000) // Simular 2 segundos de descarga
  }

  // Añade esta función después de handleDownload
  const handleDownloadAll = () => {
    // Mostrar notificación de inicio
    Swal.fire({
      title: t("downloadingTitle"),
      text: t("downloadingText"),
      icon: "info",
      timer: 2000,
      showConfirmButton: false,
    })

    // Descargar cada archivo con un pequeño retraso entre ellos
    pdfFiles.forEach((pdf, index) => {
      setTimeout(() => {
        handleDownload(pdf.id, pdf.name)
      }, index * 1000) // 1 segundo de retraso entre descargas
    })
  }

  const pdfFiles = [
    {
      id: "manual1",
      name: "Canciones y Rimas (Songs and Rhymes)",
      description: "Canciones y Rimas (Songs and Rhymes)",
      filePath: "/assets/pdfs/file1.pdf",
      fileSize: "164 KB",
    },
    {
      id: "manual2",
      name: "Carrera de Relevos de Vocabulario (Vocabulary Relay Race)",
      description: "Carrera de Relevos de Vocabulario (Vocabulary Relay Race)",
      filePath: "/assets/pdfs/file2.pdf",
      fileSize: "204 KB",
    },
    {
      id: "manual3",
      name: "Creación de Historias (Story Creation)",
      description: "Creación de Historias (Story Creation)",
      filePath: "/assets/pdfs/file3.pdf",
      fileSize: "180 KB",
    },
    {
      id: "manual4",
      name: "Juego de Memoria (Memory Match Game)",
      description: "Juego de Memoria (Memory Match Game)",
      filePath: "/assets/pdfs/file4.pdf",
      fileSize: "140 KB",
    },
    {
      id: "manual5",
      name: "Palabra del Día (Word of the Day)",
      description: "Palabra del Día (Word of the Day)",
      filePath: "/assets/pdfs/file5.pdf",
      fileSize: "156 KB",
    },
    {
      id: "manual6",
      name: "Práctica de Conversación (Conversation Practice)",
      description: "Práctica de Conversación (Conversation Practice)",
      filePath: "/assets/pdfs/file6.pdf",
      fileSize: "124 KB",
    },
    {
      id: "manual7",
      name: "Proyecto de Diccionario Ilustrado (Picture Dictionary Project)",
      description: "Proyecto de Diccionario Ilustrado (Picture Dictionary Project)",
      filePath: "/assets/pdfs/file7.pdf",
      fileSize: "200 KB",
    },
    {
      id: "manual8",
      name: "Simón Dice (Simon Says)",
      description: "Simón Dice (Simon Says)",
      filePath: "/assets/pdfs/file8.pdf",
      fileSize: "164 KB",
    },
  ]

  return (
    <Downloads
      pdfFiles={pdfFiles}
      downloadStatus={downloadStatus}
      isDownloading={isDownloading}
      handleDownload={handleDownload}
      handleDownloadAll={handleDownloadAll}
    />
  )
}

export default DownloadsContainer
